import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  useLocation,
  useRoutes,
} from "react-router-dom";

import { RootState, persistor, store } from "@store/store";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// styles
import "bootstrap/scss/bootstrap.scss";
import "@assets/css/paper-kit.css?v=1.0.0";
import "@assets/demo/demo.css?v=1.0.0";
import "react-nice-scroll/dist/styles.css";
import "@assets/css/style.css?v=1.1.0";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

// pages
import Exam from "@components/Demo/Exam";
import Icons from "@components/Demo/Icons";
import Dashboard from "@views/Pages/Dashboard/Dashboard";
import RaffleDetail from "@views/Pages/Dashboard/RaffleDetail";
import Landing from "@views/Pages/Landing";
import FavoriteRaffle from "@views/Pages/Profile/FavoriteRaffle";
import PlayedRaffles from "@views/Pages/Profile/PlayedRaffles";
import ProfileDetails from "@views/Pages/Profile/ProfileDetails";
import ProfileTicket from "@views/Pages/Profile/ProfileTicket";

import Login from "@views/Pages/Login";
// others
import Widget from "@components/widget";
import { routes } from "@const/routes";
import { RaffleResult } from "@views/Pages/Dashboard/RaffleResult";
import { RaffleResultDetail } from "@views/Pages/Dashboard/RaffleResultDetail";
// import GlobalStyle from "./Global";
import { DashboardLayout } from "./Layouts/DashboardLayout/DashboardLayout";
import useSession from "./hooks/useSession";
import VerifiedEmail from "@views/Pages/Verify";
import Gift from "@views/Pages/Gift";
import { HelmetProvider } from "react-helmet-async";
import Daburlogo from "@assets/img/dabur-color.svg";
// import GlobalStyle from './theme/globalStyles';
// console.log(tokens.colors.bgPrimary,"sudhir");

// import { ThemeProvider } from "styled-components";
// import {
//   daburTheme,
//   primaryTheme,
//   secondaryTheme,
//   underArmorTheme,
// } from "./theme/tokens";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Preview from "@views/Pages/PreviewPage";
import Contact from "@views/Pages/Contact";
import SpinWheelGame from "@views/Pages/SpinWheelGame";
import useThemeInitializer from "./ThemeInitializer";
import { DashboardPreview } from "./Layouts/DashboardLayout/DashboardPreview";
import TicketGenerator from "@views/Pages/ticketGenerator";
import ScrollToTop from "@components/ScrollToTop";
import ErrorBoundary from "@components/ErrorBoundary";
import { initAnalytics, trackPageView, trackFunnel } from "@utils/analytics";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App: React.FC = () => {
  // const [isDarkMode, setIsDarkMode] = useState("dabur");
  // const toggleTheme = () => setIsDarkMode((prev) => !prev);
  const notice = useSelector((state: RootState) => state.notice);

  // const [theme, setTheme] = useState<
  //   "primary" | "secondary" | "dabur" | "underArmor"
  // >("primary");

  // useEffect(() => {
  //   document.body.setAttribute("data-theme", theme);
  // }, [theme]);

  useEffect(() => {
    switch (notice.type) {
      case "SUCCESS":
        toast.success(notice.content);

        break;
      case "ERROR":
        toast.error(notice.content);

        break;
      case "WAITING":
        toast.warning(notice.content);

        break;
      default:
        break;
    }
  }, [notice]);

  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <>
      {/* <ThemeProvider
        theme={
          isDarkMode 
            ? daburTheme
            : isDarkMode === "underArmor"
            ? underArmorTheme
            : primaryTheme
        }
      > */}
      {/* <ThemeProvider theme={theme === "secondary" ? secondaryTheme : primaryTheme}> */}
      {/* <button onClick={toggleTheme} style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
        }}>
        Toggle Theme
      </button> */}
      {/* <select
        // className="position-fixed left-0 z-3"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 9999,
        }}
        value={theme}
        onChange={(e) => setTheme(e.target.value as any)}
      >
        <option value="primary">Primary</option>
        <option value="secondary">Secondary</option>
        <option value="dabur">Dabur</option>
        <option value="underArmor">Under Armor</option>
      </select> */}
      <HelmetProvider>
        <BrowserRouter>
          {/* <GlobalStyle /> */}
          <ScrollToTop />
          <RouterList />
        </BrowserRouter>
        <ToastContainer theme="light" />
      </HelmetProvider>
      {/* </ThemeProvider> */}
    </>
  );
};

const RouterList = () => {
  const location = useLocation();
  const isLoggedIn = useSelector((state: RootState) => state.auth.token);

  useSession({ isLoggedIn: !!isLoggedIn });

  const PrivateRoutes = () => {
    return isLoggedIn ? <Outlet /> : <Navigate to={routes.login} replace />;
  };

  const { isDabur, fetchTheme } = useThemeInitializer()
  const landingElement = isLoggedIn
    ? <Navigate to={routes.dashboard} replace />
    : <Navigate to={routes.login} replace />;

  useEffect(() => {
    const page = new URL(window.location.href);
    const path = page.pathname;
    if (path === routes.landing || path === routes.login) {
      fetchTheme("landing");
    } else {
      fetchTheme("dashboard");
    }
  }, []);

  useEffect(() => {
    initAnalytics();
    trackPageView(location.pathname + location.search);

    // Track gamecenter open when user hits dashboard
    if (location.pathname === "/dashboard") {
      trackFunnel.gamecenterOpen();
    }
  }, [location.pathname, location.search]);

  // Track exit point on page unload
  useEffect(() => {
    const handleBeforeUnload = () => {
      trackFunnel.exitPoint(location.pathname);
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [location.pathname]);

  return useRoutes([
    { path: routes.landing, element: landingElement },
    { path: routes.verify, element: <VerifiedEmail /> },
    { path: routes.gift, element: <Gift /> },
    { path: routes.preview, element: <Preview /> },
    // { path: routes.spinWheel, element: <SpinWheelGame /> },
    // { path: routes.contact, element: <Contact /> },
    {
      element: isLoggedIn ? <Navigate to={routes.dashboard} replace /> : <Login />,
      children: [
        { path: routes.login }
      ],
    },
    {
      element: isLoggedIn ? <Navigate to={routes.dashboard} replace /> : <Login />,
      children: [
        { path: routes.referFriend }
      ],
    },
    {
      element: <PrivateRoutes />,
      children: [
        // {
        //   path: routes.ticket,
        //   element: (
        //     <ProfileTicket
        //       Available=""
        //       Used=""
        //       Registered=""
        //       Expired=""
        //     />
        //   ),
        // },
        // { path: routes.profile, element: <ProfileDetails /> },
        // { path: routes.favoriteRaffle, element: <FavoriteRaffle /> },
        // { path: routes.playedRaffles, element: <PlayedRaffles /> },
      ],
    },
    // { path: routes.favoriteRaffle, element: <FavoriteRaffle /> },
    { path: routes.dashboardPreview, element: <DashboardPreview /> },
    {
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to={routes.login} replace />,
      children: [
        { path: routes.dashboard, element: <Dashboard title="Dashboard" /> },
        { path: routes.ticketGenerator, element: <TicketGenerator /> },
        { path: routes.raffleResult, element: <RaffleResult title="Completed Raffle Results" /> },
        { path: routes.raffleResultDetail, element: <RaffleResultDetail title="Raffle result" /> },
        { path: routes.favoriteRaffle, element: <FavoriteRaffle /> },
        { path: routes.contact, element: <Contact /> },
        { path: routes.raffleDetail, element: <RaffleDetail /> },
        { path: routes.playedRaffles, element: <PlayedRaffles /> },
        { path: routes.profile, element: <ProfileDetails /> },
        {
          path: routes.ticket,
          element: (
            <ProfileTicket
              Available=""
              Used=""
              // Registered=""
              Expired=""
            />
          ),
        },
      ],
    },
    // { path: routes.exam, element: <Exam /> },
    // { path: routes.icons, element: <Icons /> },
    // { path: routes.widget, element: <Widget /> },
    { path: "*", element: <Navigate to={routes.landing} replace /> },
  ]);
};

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PersistGate>
  </Provider>
);
